var map = {
	"./Email.svg": 489,
	"./email-icon-hover.svg": 490,
	"./email-icon-hover_1.svg": 491,
	"./email-icon.svg": 492,
	"./email-icon_1.svg": 493,
	"./facebook-1.svg": 494,
	"./facebook-icon-2.svg": 495,
	"./facebook-icon-hover-2.svg": 496,
	"./facebook-icon-hover.svg": 497,
	"./twitter-1.svg": 498,
	"./twitter-icon-2.svg": 499,
	"./twitter-icon-hover-2.svg": 500,
	"./twitter-icon-hover.svg": 501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;